import { Link, useLocation } from "react-router-dom";
import { Card, Badge } from "react-bootstrap";
import { useSelector } from "react-redux";
import Loader from "./Loader";
import Message from "./Message";
import PriceWithSale from "./PriceWithSale";
import { useGetSaleProductsQuery } from "../slices/productsApiSlice";
import { buildProductUrl, getCurrentRoute } from "../utils/navigation";

export default function SaleMarqueeRow({ limit = 12 }) {
  const location = useLocation();
  const { userInfo } = useSelector((state) => state.auth);
  const isTieredUser = Boolean(userInfo?.tier?.id);
  const { data: products = [], isLoading, error } = useGetSaleProductsQuery(
    limit,
    { skip: isTieredUser }
  );

  if (isTieredUser) return null;

  if (isLoading) return <Loader />;
  if (error) {
    return (
      <Message variant="danger">
        {error?.data?.message || error?.error || "Error loading sale products"}
      </Message>
    );
  }

  if (!products.length) return null;

  // duplicate for seamless loop
  const items = [...products, ...products];

  return (
    <section className="sale-marquee-wrap mt-5">
      <div className="sale-section-header">
        <div>
          <div className="sale-eyebrow">Limited-time offers</div>
          <h3 className="mb-1">On Sale</h3>
          <p className="text-muted mb-0">
            Save on top-rated parts while inventory lasts.
          </p>
        </div>
        <Badge bg="danger-subtle" text="danger" className="sale-pill">
          Today&apos;s deals
        </Badge>
      </div>

      <div className="sale-marquee">
        <div className="sale-marquee-track">
          {items.map((p, idx) => {
            return (
              <Link
                key={`${p._id}-${idx}`}
                to={buildProductUrl(p._id, location)}
                state={{ from: getCurrentRoute(location) }}
                className="sale-tile-link"
              >
                <Card className="sale-tile">
                  <div className="sale-img-wrap">
                    <img
                      className="sale-img"
                      src={p.image}
                      alt={p.name}
                      loading="lazy"
                    />
                  </div>

                  <Card.Body className="py-3">
                    <div className="sale-title" title={p.name}>
                      {p.name}
                    </div>
                    <div className="sale-price">
                      <PriceWithSale
                        price={Number(p.price)}
                        salePrice={p.salePrice}
                        saleStartAt={p.saleStartAt}
                        saleEndAt={p.saleEndAt}
                        tierPrice={
                          isTieredUser && p?.tierPrice != null
                            ? Number(p.tierPrice)
                            : null
                        }
                        showTierTag={Boolean(isTieredUser && p?.tierPrice != null)}
                        forceBasePrice={isTieredUser && p?.tierPrice == null}
                      />
                    </div>
                  </Card.Body>
                </Card>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
